import { Outlet } from "react-router-dom";

import styles from "./Header.module.css";

const Header = () => {
    return (
        <div className={styles.headerlayout}>
            <Outlet />
        </div>
    );
};

export default Header;
